module.exports = __webpack_public_path__ + "static/Automatic_Detergent_Dosing_System_s-5f3acacbaf02e837a51ae661d0e880fa.png";